<template>
  <div class="mb-3">
    <div id="crumbs">
      <a href="/#/"><i class="fas fa-home"></i></a>
      <span v-for="crumb in crumbs" v-bind:key="crumb.link">
        <span style="color:#CCC"> / </span>
        <router-link v-if="!crumb.lastLink" :to="'/' + crumb.link">{{crumb.name}}</router-link>
        <span v-if="crumb.lastLink">{{crumb.name}}</span>
      </span>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {

    }
  },
  computed: {
    crumbs: function () {
      var crumbs = this.$route.fullPath.split('/').map(function (x) {
        return {name: x.replace(/-/g, ' '), link: x, lastLink: false}
      })
      crumbs.shift()
      if (this.$route.params.name !== undefined && this.$route.fullPath.indexOf('recognition') === -1 && this.$route.fullPath.indexOf('innovation-awards') === -1) {
        crumbs.pop()
      }
      crumbs[crumbs.length - 1].lastLink = true
      return crumbs
    }
  }
}
</script>

<style lang="less">
  #crumbs {
    text-transform: uppercase;
  }
  .router-link-active {
    color: #007bff !important;
    transition: all 0.25s;
    &:hover {
      color: #00508F !important
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumbs.vue